import React, { useCallback } from 'react';
import { FilterBaseComposition } from 'components/view/FilterBase';
import Dropdown from 'components/connectedForm/Dropdown';
import QueryDropdown from 'components/connectedForm/QueryDropdown';

const getBadgeText = (committedValues) => {
  if (!committedValues.objects || committedValues.objects.length === 0) {
    return null;
  }
  return committedValues.objects.length;
};

const getDescription = (committedValues) => {
  if (!committedValues.objects) {
    return 'All';
  }

  const text = committedValues.objects.value;
  if (text === '') {
    return 'Unknown Codes';
  }
  return text;
};

const FilterObject = (props) => {
  const getQueryFilters = useCallback(
    (committedValues) => {
      if (!committedValues.objects) {
        return null;
      }

      return [
        {
          fieldName: `${props.fieldName}.id`,
          operation: 'EQUALS',
          value: committedValues.objects.value,
        },
      ];
    },
    [props.fieldName]
  );

  const renderPopout = (setInputRef, filterValues, handleChange) => {
    const { id, options, ...selectProps } = props;
    const Select = options ? Dropdown : QueryDropdown;

    return (
      <div style={{ width: '450px', padding: '4px 6px 0px 6px' }}>
        <Select
          {...selectProps}
          setInputRef={setInputRef}
          includeLabel={false}
          value={filterValues.objects}
          multi={true}
          options={options}
          inputCols={1}
          onChange={(value) => handleChange('objects', value)}
          onBlur={() => {}}
        />
      </div>
    );
  };

  return (
    <FilterBaseComposition
      {...props}
      getBadgeText={getBadgeText}
      getDescription={getDescription}
      getQueryFilters={getQueryFilters}
      renderPopout={renderPopout}
    />
  );
};

export default FilterObject;
